import React, { useState } from 'react'
import { useDrawing } from '../../context/DrawingContext'
import styles from './LayerItem.module.css'
import { AlertModal, ConfirmModal } from '../AlertModal'

const LayerItem = ({ layer }) => {
  const { state, dispatch } = useDrawing()
  const [showAlert, setShowAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const handleLayerSelect = () => {
    dispatch({ type: 'SET_ACTIVE_LAYER', payload: layer.id })
  }

  const handleVisibilityToggle = (e) => {
    e.stopPropagation()
    dispatch({ type: 'TOGGLE_LAYER_VISIBILITY', payload: layer.id })
  }

  const handleDeleteLayer = (e) => {
    e.stopPropagation()
    if (state.layers.length <= 1) {
      setAlertMessage('최소 하나의 레이어는 필요합니다.')
      setShowAlert(true)
      return
    }
    setShowDeleteConfirm(true)
  }

  const confirmDeleteLayer = () => {
    dispatch({ type: 'DELETE_LAYER', payload: layer.id })
    setShowDeleteConfirm(false)
  }

  return (
    <div
      className={`${styles.layerItem} ${
        layer.active ? styles.active : ''
      }`}
      onClick={handleLayerSelect}
    >
      <div className={styles.layerContent}>
        <button
          className={`${styles.visibilityButton} ${
            layer.visible ? styles.visible : styles.hidden
          }`}
          onClick={handleVisibilityToggle}
          title={layer.visible ? '레이어 숨기기' : '레이어 보이기'}
        >
          <i className={layer.visible ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
        </button>

        <div className={styles.layerPreview}>
          <div className={styles.thumbnail}></div>
        </div>

        <div className={styles.layerInfo}>
          <span className={styles.layerName}>{layer.name}</span>
          {layer.active && <span className={styles.activeIndicator}>활성</span>}
        </div>
      </div>

      <div className={styles.layerActions}>
        <button
          className={styles.actionButton}
          title="레이어 삭제"
          onClick={handleDeleteLayer}
        >
          <i className="fas fa-trash"></i>
        </button>
      </div>

      <AlertModal
        isOpen={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
      />

      <ConfirmModal
        isOpen={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={confirmDeleteLayer}
        title="레이어 삭제"
        message="이 레이어를 삭제하시겠습니까?"
        confirmText="삭제"
        cancelText="취소"
        confirmButtonColor="#ef4444"
      />
    </div>
  )
}

export default LayerItem